// src/context/AuthContext.js

import React, { useContext, useState, useEffect, createContext } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebaseconfig";

// Cria o contexto
const AuthContext = createContext();

// Hook customizado para usar o contexto facilmente
export function useAuth() {
  return useContext(AuthContext);
}

// Componente "Provider" que vai envolver sua aplicação
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Esta é a mesma lógica do seu hook, mas agora dentro do Provider
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        setUser(null);
        setUserData(null);
        setLoading(false);
      } else {
        setUser(currentUser);
        const userDocRef = doc(db, "usuarios", currentUser.uid);
        const unsubscribeFirestore = onSnapshot(
          userDocRef,
          (docSnap) => {
            if (docSnap.exists()) {
              setUserData(docSnap.data());
            } else {
              setUserData(null);
            }
            setLoading(false);
          },
          (error) => {
            console.error("Erro no AuthContext:", error);
            setLoading(false);
          },
        );
        return () => unsubscribeFirestore();
      }
    });
    return () => unsubscribeAuth();
  }, []);

  const value = {
    user,
    userData,
    loading,
  };

  // Fornece o 'value' para todos os componentes filhos
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
